import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, 
  tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, ToggleButton, Typography, } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PlaceService from "../../../Services/place/PlaceService";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 12,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function State() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red",fontFamily: 'Times New Roman',
  };
  const mystyle2 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };
  const [values, setvalues] = useState({
    stateId: '',
    coun_name: '',
    del_state: '',
    state_code: '',
    cust_code: '',
    cgst: '',
    sgst: '',
    igst: '',
  });
  const [error, setError] = useState({ countryName: false, statename: false, StateCode: false });
  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(true);
  const [deleteDsa, setDeleteDsa] = useState(true);

  const [Deletes, setDelete] = useState(false);
  const [save, setSave] = useState(false);
  const [update, setUpdate] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [StateDetails, setStateDetails] = useState([]);
  const [FilterDetails, setFilterDetails] = useState([]);

  const [cntryDetails, setCntryDetails] = useState([]);

  const coun_namehandlechange = (e) => {
    setvalues({ ...values, coun_name: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const del_statehandlechange = (e) => {
    setvalues({ ...values, del_state: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const state_codehandlechange = (e) => {
    setvalues({ ...values, state_code: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const cust_codehandlechange = (e) => {
    setvalues({ ...values, cust_code: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const cgsthandlechange = (e) => {
    setvalues({ ...values, cgst: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const sgsthandlechange = (e) => {
    setvalues({ ...values, sgst: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };
  const igsthandlechange = (e) => {
    setvalues({ ...values, igst: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') })
  };

  //getDataGrids

  const getData = async () => {
    PlaceService.getCountryName().then((res) => {
      setCntryDetails(res.data);
    });
  }
  const getDeliveryStateName = async () => {
    PlaceService.getDeliveryStateName().then((res) => {
      setStateDetails(res.data);
      setFilterDetails(res.data);
    });
  }

  useEffect(() => {
    getData();
    const getDeliveryStateName = async () => {
      PlaceService.getDeliveryStateName().then((res) => {
        setStateDetails(res.data);
        setFilterDetails(res.data);
        console.log('values===' + JSON.stringify(res))
      });
    }
    getDeliveryStateName();
  }, []);
  ///
  const icondelete = () => {
    return <DeleteOutlineRoundedIcon style={{ color: 'red' }} />
  }
  //tableClickj

  const EditStateDetails = (item) => {
    setSaveDsa(true);
    setUpdateDsa(false);
    setDeleteDsa(false);
    setDelete(false);
    setSave(false);
    setUpdate(false);
    setvalues({
      ...values, stateId: item.deliveryStateId, coun_name: item.countryId, del_state: item.deliveryStateName, cgst: item.cgstRate,
      cust_code: item.customCode, igst: item.igstRate, sgst: item.sgstRate, state_code: item.stateCode
    });
  }

  // handelclocse/Opens
  const handleClose = () => {
    setOpen(false);
  }

  //clickEvente

  const validate = () => {
    if (values.coun_name !== '') {
      if (values.del_state !== '') {
        if (values.state_code !== '') {
          return true;
        } else {
          document.getElementById('dlvrstateCode').focus();
          setError({ ...error, StateCode: true });
          setOpen(true); setSeverity('warning'); setMessage('Please Enter a StateCode')
        }
      } else {
        document.getElementById('dlvrstate').focus();
        setError({ ...error, statename: true });
        setOpen(true); setSeverity('warning'); setMessage('Please Enter a StateName')
      }
    } else {
      document.getElementById('cntry').focus();
      setError({ ...error, countryName: true });
      setOpen(true); setSeverity('warning'); setMessage('Please Select a Contry')
    }
    return false;
  }

  const saveState = () => {
    if (validate() === true) {
      setSaveDsa(true);
      setSave(true);
      let details = {
        deliveryStateName: values.del_state, countryId: values.coun_name, stateCode: values.state_code,
        customCode: values.cust_code, cgstRate: values.cgst, sgstRate: values.sgst, igstRate: values.igst
      }
      PlaceService.insertDeliveryStateName(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }
  const UpdateState = () => {
    if (validate() === true) {
      if (values.stateId !== '') {
        setUpdateDsa(true);
        setUpdate(true);
        let details = {
          deliveryStateId: values.stateId, deliveryStateName: values.del_state, countryId: values.coun_name, stateCode: values.state_code,
          customCode: values.cust_code, cgstRate: values.cgst, sgstRate: values.sgst, igstRate: values.igst
        }
        PlaceService.updateDeliveryStateName(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage(message);
          } else {
            setOpen(true); setSeverity('error'); setMessage('Updation Failed');
          } refresh();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
        })

      } else {
        setOpen(true); setSeverity('warning'); setMessage('Please Select a State'); refresh();
      }
    }
  }

  const DeleteState = () => {
    if (values.stateId !== '') {
      setDeleteDsa(true);
      setDelete(true);
      setalertopen(true)
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Please Select a State'); refresh();
    }
  }

  const refresh = () => {
    setPage(0)
    setvalues({ ...values, stateId: '', coun_name: '', del_state: '', cgst: '', cust_code: '', igst: '', sgst: '', state_code: '' });
    setError({ countryName: false, statename: false, StateCode: false });
    setSaveDsa(false);
    setUpdateDsa(true);
    setDeleteDsa(true);
    setDelete(false);
    setSave(false);
    setUpdate(false);
    getDeliveryStateName();
  }
  const cntryNameSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { CountryNMsearch(e.target.value) }} placeholder="Search" />
  }
  const cntryStateSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { CountryStsearch(e.target.value) }} placeholder="Search" />
  }
  const CountryNMsearch = (searchedVal) => {
    const filteredRows = StateDetails.filter((row) => {
      return row.countryName.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
    });
    if (searchedVal.length < 1) {
      setFilterDetails(StateDetails)
    } else {
      setFilterDetails(filteredRows)
    }
  }
  const CountryStsearch = (searchedVal) => {
    const filteredRows = StateDetails.filter((row) => {
      return row.deliveryStateName.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
    });
    if (searchedVal.length < 1) {
      setFilterDetails(StateDetails)
    } else {
      setFilterDetails(filteredRows)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setvalues({ ...values, stateId: item.deliveryStateId })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    PlaceService.deleteDeliveryStateName(values.stateId).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage(message);
      } refresh();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
    })
    setalertopen(false)
  }

  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/Country');
  }
  const ForwordBotton =()=>{
    navigate('/ClearanceLoc');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center><h6>ARE YOU SURE,</h6></center>
          <h6>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home />
      <Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
              <Row>
                <Col xs={1}>
            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}} >
                State Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={4}>
                  <label style={mystyle1}>CountryName*</label>
                </Col>
                <Col xs={8}>
                  <Form.Select size="sm" type="text" style={mystyle} id='cntry' isInvalid={error.countryName}
                    value={values.coun_name} onChange={coun_namehandlechange} required>
                    <option value={''}></option>
                    {cntryDetails.map((item) => (
                      <option value={item.countryId}>{item.countryName}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle1}>DeliveryState*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} id='dlvrstate' isInvalid={error.statename}
                    value={values.del_state} onChange={del_statehandlechange} required />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle1}>StateCode*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} id='dlvrstateCode' isInvalid={error.StateCode}
                    value={values.state_code} onChange={state_codehandlechange} required />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>CustomCode</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle}
                    value={values.cust_code} onChange={cust_codehandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>CGSTRate(%)</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="number" style={mystyle}
                    value={values.cgst} onChange={cgsthandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>SGSTRate(%)</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="number" style={mystyle}
                    value={values.sgst} onChange={sgsthandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>IGSTRate(%)</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="number" style={mystyle}
                    value={values.igst} onChange={igsthandlechange} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman'}} size="sm" disabled={saveDsa} onClick={saveState}>
                    {save ? 'processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="info" size="sm" disabled={updateDsa} onClick={UpdateState}>
                    {update ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="danger" size="sm" disabled={deleteDsa} onClick={DeleteState}>
                    {Deletes ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
                <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                  Existing State Details
                </Typography>
                </Col>
                <Col xs={1}>
                  {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>   */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>SlNo</StyledTableCell>
                        <StyledTableCell>CountryName{cntryNameSrch()}</StyledTableCell>
                        <StyledTableCell>DeliveryStateName{cntryStateSrch()}</StyledTableCell>
                        <StyledTableCell>StateCode</StyledTableCell>
                        <StyledTableCell>CustomCode</StyledTableCell>
                        <StyledTableCell>CGST</StyledTableCell>
                        <StyledTableCell>SGST</StyledTableCell>
                        <StyledTableCell>IGST</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {FilterDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <StyledTableRow hover key={item.deliveryStateId} onClick={() => EditStateDetails(item)}>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.countryName}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.deliveryStateName}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.stateCode}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.customCode}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.cgstRate}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.sgstRate}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.igstRate}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{icondelete()}</lu></StyledTableCell>
                          </StyledTableRow>))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={FilterDetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default State;
